import HeroBanners from "@/components/home/HeroBanners";
import BrandButtons from "@/components/home/BrandButtons";
import CategoryButtons from "@/components/home/CategoryButtons";
import NewestProducts from "@/components/home/NewestProducts";
import PopularRacketsSection from "@/components/home/PopularRacketsSection";
import TopProPlayers from "@/components/home/TopProPlayers";
import SignatureRackets from "@/components/home/SignatureRackets";

import GiftCardSection from "@/components/home/GiftCardSection";
import ArticlesSection from "@/components/home/ArticlesSection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import InstagramSection from "@/components/home/InstagramSection";
import SEO from "@/components/SEO";

const Index = () => {
  return (
    <>
      <SEO
        title="Padel Veikals Latvijā — Raketes, Apavi, Bumbas | PADELCORNER.LV"
        description="Padel Corner — tavs padel veikals Rīgā. Raketes, apavi, bumbas, apģērbs un aksesuāri. Oriģināli zīmoli, ātra piegāde 24-48h, bezmaksas piegāde no €150."
        canonical="/lv"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Padel Corner",
            legalName: "SIA 2MOVE",
            url: "https://padelcorner.lv/",
            logo: "https://padelcorner.lv/logo.png",
            email: "info@padelcorner.lv",
            telephone: "+371 22588218",
            sameAs: ["https://www.instagram.com/padelcorner.lv/"],
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "PADELCORNER.LV",
            url: "https://padelcorner.lv/",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://padelcorner.lv/products?search={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "Store",
            name: "Padel Corner",
            image: "https://padelcorner.lv/logo.png",
            url: "https://padelcorner.lv/",
            telephone: "+371 22588218",
            email: "info@padelcorner.lv",
            priceRange: "€€",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Rīga",
              addressCountry: "LV",
            },
            areaServed: { "@type": "Country", name: "Latvia" },
          },
        ]}
      />
      <HeroBanners />
      <BrandButtons />
      <SignatureRackets />
      <GiftCardSection />
      <CategoryButtons />
      <PopularRacketsSection />
      <TopProPlayers />

      <NewestProducts />

      <section className="container mx-auto px-4 py-12 md:py-16">
        <ArticlesSection />
      </section>

      <section className="container mx-auto px-4 pb-12 md:pb-16">
        <InstagramSection />
      </section>

      <TestimonialsSection />
    </>
  );
};

export default Index;
